"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboType = exports.NutrientUnit = exports.NutrientName = exports.ProductAllergens = exports.ProductUpdateAction = exports.LANGUAGE_LOCALE_MAP = exports.LOCALE = exports.TagType = exports.EntityType = exports.UnitType = void 0;
var UnitType;
(function (UnitType) {
    UnitType["Units"] = "Units";
    UnitType["Volume"] = "Volume";
    UnitType["Weight"] = "Weight";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
var EntityType;
(function (EntityType) {
    EntityType["Variant"] = "variant";
    EntityType["Product"] = "product";
    EntityType["Modifier"] = "modifier";
    EntityType["Page"] = "page";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
var TagType;
(function (TagType) {
    TagType["GENERAL"] = "GENERAL";
    TagType["DIETARY"] = "DIETARY";
})(TagType = exports.TagType || (exports.TagType = {}));
var LOCALE;
(function (LOCALE) {
    LOCALE["ENGLISH_US"] = "ENGLISH_US";
    LOCALE["HINDI"] = "HINDI";
    LOCALE["DUTCH"] = "DUTCH";
    LOCALE["CHINESE"] = "CHINESE";
    LOCALE["SPANISH_SPAIN"] = "SPANISH_SPAIN";
})(LOCALE = exports.LOCALE || (exports.LOCALE = {}));
exports.LANGUAGE_LOCALE_MAP = {
    [LOCALE.ENGLISH_US]: 'en-US',
    [LOCALE.HINDI]: 'hi-IN',
    [LOCALE.SPANISH_SPAIN]: 'es-ES',
    [LOCALE.DUTCH]: 'de-DE',
    [LOCALE.CHINESE]: 'zh-CN',
};
var ProductUpdateAction;
(function (ProductUpdateAction) {
    ProductUpdateAction["GENERAL"] = "GENERAL";
    // INVENTORY will ignore update cached of catalogues
    ProductUpdateAction["INVENTORY"] = "INVENTORY";
})(ProductUpdateAction = exports.ProductUpdateAction || (exports.ProductUpdateAction = {}));
var ProductAllergens;
(function (ProductAllergens) {
    ProductAllergens["CELERY"] = "Celery";
    ProductAllergens["CEREAL_WITH_GLUTEN"] = "Cereals with gluten";
    ProductAllergens["CRUSTACEANS"] = "Crustaceans";
    ProductAllergens["EGGS"] = "Eggs";
    ProductAllergens["FISH"] = "Fish";
    ProductAllergens["GARLIC"] = "Garlic";
    ProductAllergens["GINGER"] = "Ginger";
    ProductAllergens["GLUTEN"] = "Gluten";
    ProductAllergens["GLUTEN_NUTS"] = "Gluten Nuts";
    ProductAllergens["LEGUME"] = "Legumes";
    ProductAllergens["LUPIN"] = "Lupin";
    ProductAllergens["MANGO"] = "Mango";
    ProductAllergens["MILK"] = "Milk";
    ProductAllergens["MOLLUSCS"] = "Molluscs";
    ProductAllergens["MUSTARD"] = "Mustard";
    ProductAllergens["ONION"] = "Onion";
    ProductAllergens["PEANUTS"] = "Peanuts";
    ProductAllergens["SESAME_SEEDS"] = "Sesame seeds";
    ProductAllergens["SOYBEANS"] = "Soybeans";
    ProductAllergens["SULPHUR_DIOXIDE_SULPHITES"] = "Sulphur dioxide & sulphites";
    ProductAllergens["TREE_NUTS"] = "Tree nuts";
})(ProductAllergens = exports.ProductAllergens || (exports.ProductAllergens = {}));
var NutrientName;
(function (NutrientName) {
    NutrientName["ENERGY"] = "Energy";
    NutrientName["FAT"] = "Fat";
    NutrientName["SATURATES"] = "Saturates";
    NutrientName["CARBOHYDRATE"] = "Carbohydrate";
    NutrientName["SUGAR"] = "Sugar";
    NutrientName["PROTEIN"] = "Protein";
    NutrientName["SALT"] = "Salt";
    NutrientName["FIBRE"] = "Fibre";
})(NutrientName = exports.NutrientName || (exports.NutrientName = {}));
var NutrientUnit;
(function (NutrientUnit) {
    NutrientUnit["KCAL"] = "kcal";
    NutrientUnit["CAL"] = "cal";
    NutrientUnit["KJ"] = "kJ";
    NutrientUnit["G"] = "g";
})(NutrientUnit = exports.NutrientUnit || (exports.NutrientUnit = {}));
var ComboType;
(function (ComboType) {
    ComboType["REGULAR"] = "REGULAR";
    ComboType["FIXED"] = "FIXED";
})(ComboType = exports.ComboType || (exports.ComboType = {}));
//# sourceMappingURL=products.js.map